export const painPoints = [
  {
    title: "No sabes qué producto elegir",
    text: "Te salen ricos los brownies, las cookies y los alfajores… pero no sabes con cuál empezar ni cuáles conviene ofrecer.",
  },
  {
    title: "Te da miedo cobrar mal",
    text: "Pones un precio “a ojo”, y al final del mes no sabes si ganaste o si estuviste regalando tu tiempo y tus ingredientes.",
  },
  {
    title: "Publicas, pero nadie pregunta",
    text: "Subes una foto a Instagram de vez en cuando, sin un plan, y sientes que nadie la ve.",
  },
  {
    title: "Los pedidos te desbordan",
    text: "Mensajes sueltos en WhatsApp, entregas anotadas en un papel, cobros que se olvidan. Todo vive en tu cabeza.",
  },
];
